import Vue from 'vue';
import adjustmentTransformer from './../../transformers/adjustment';
import store from './../../store';

const success = (data, resolve) => {
  store.dispatch('fetchCurrentAdjustment', adjustmentTransformer.fetch(data));
  resolve(adjustmentTransformer.fetch(data));
};

const failed = (errors, reject) => {
  if (errors.error) {
    reject(errors.error);
    return;
  } else if (errors.message) {
    reject(errors);
    return;
  }

  reject(adjustmentTransformer.fetch(errors));
};

export default (id, adjustment) => (
  new Promise((resolve, reject) => {
    Vue.$http.put(`/adjustments/update-draft/${id}`, adjustment)
    .then((response) => {
      success(response.data, resolve);
    })
    .catch((error) => {
      failed(error.response.data, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/adjustment/updateDraft.js